import { OWNABLE } from '@Constants/Icons';
import OwnableTheme from '@Theme';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { Platform } from 'react-native';
import styled, { css } from 'styled-components/native';

import { useHamburgerButtonPresenter } from './HamburgerButton.presenter';
import HamburgerButtonPressable from './HamburgerButtonPressable';

const StyledOwnableButtonContainer = styled.View`
  position: absolute;
  flex-direction: row;
  top: 20px;
  right: 20px;
  align-items: center;
  z-index: 1000000;
`;

const StyledHamburgerContainer = styled.Pressable<{
  borderRadius: number;
  bgColor: string;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  border-radius: 60px;
  background-color: ${({ bgColor }) => bgColor};
  filter: drop-shadow(0px 0px 20px #9b9b9b);
  ${Platform.OS === 'web' &&
  css`
    cursor: pointer;
  `};
`;

const HamburgerButton = () => {
  const { onPress, isOpen } = useHamburgerButtonPresenter();

  useEffect(
    () => () => {
      isOpen.set(false);
    },
    []
  );

  return (
    <StyledOwnableButtonContainer>
      <StyledHamburgerContainer
        borderRadius={OWNABLE / 2}
        onPress={onPress}
        bgColor={
          isOpen.value ? OwnableTheme.colors.black : OwnableTheme.colors.white
        }
      >
        <HamburgerButtonPressable
          color={
            isOpen.value ? OwnableTheme.colors.white : OwnableTheme.colors.black
          }
        />
      </StyledHamburgerContainer>
    </StyledOwnableButtonContainer>
  );
};

export default observer(HamburgerButton);
